import styled from 'styled-components'

import {spacingUnit} from '../../cssConstants/spacing'

export const Article = styled.article`
  margin-right: ${spacingUnit}rem;
  margin-left: ${spacingUnit}rem;
`
